<template>
  <div class="image-container" ref="imageContainer">
    <img 
      ref="image"
      src="@/assets/image7 (2)_11zon.webp"
      alt="Imagen de ejemplo"
      class="cover-image"
    >
    <div class="overlay"></div>
    
    <div ref="textRef" class="text-overlay"> <!-- Texto elegante sobre la imagen 
      <p class="subtitle">
        Te espero para que formes parte de uno de los mejores días de mi vida.
      </p>-->
      <p class="firma">
       With love,<br>
        <span>Jade Chávez
</span>
      </p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'CoverImageComponent',
  setup() {
    const image = ref(null);
    const textRef = ref(null);
    const imageContainer = ref(null);

    onMounted(() => {
      gsap.fromTo(
        image.value,
        { opacity: 0, scale: 1.1 },
        { 
          opacity: 1, 
          scale: 1, 
          duration: 1.5, 
          ease: 'power2.out',
          scrollTrigger: {
            trigger: imageContainer.value,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );

      gsap.fromTo(
        textRef.value,
        { opacity: 0, y: 50 },
        { 
          opacity: 1, 
          y: 0, 
          duration: 1.8, 
          delay: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: imageContainer.value,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );
    });

    return { textRef, image, imageContainer };
  },
};
</script>

<style scoped>
.image-container {
  width: 100vw;
  height: 500px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  filter: brightness(80%);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.text-overlay {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
  color: #fff;
  z-index: 10;
  opacity: 0;
  padding: 0 20px;
}

.subtitle {
  font-size: 20px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 300;
  letter-spacing: 1px;
  margin-bottom: 15px;
}

.firma {
  font-size: 16px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 400;
  margin: 0;
}

.firma span {
  display: block;
  margin-top: 5px;
  font-family: 'FeelingPassionate';
  font-size: 1.6rem;
}
</style>
